export default [
  { to: 'allmant', title: 'Allmänt' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'information', title: 'Information' },
  { to: 'dosberakning', title: 'Dosberäkning', lockExternal: true },
];
